import axios from 'axios';
import { ContentModel } from '@shared/hooks';

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL;

export function fetchContent(id: number | string) {
  return axios.get<ContentModel>(`${API_URL}/api/game-dev/content/${id}`).then((res) => res.data);
}
